import { ofType } from 'redux-observable'
import { map } from 'rxjs/operators'
import { websocketAction } from '../../utils/redux'
import { getSpaceList } from './redux/timeTableSlice'

const WS = {
    timetableUpdated: websocketAction('timetable_updated'),
}

const refreshTimetable = (action$) => action$.pipe(
    ofType(WS.timetableUpdated.type),
    map(getSpaceList),
)

export default [refreshTimetable]
